import React, { Component } from 'react';


import "./Style.css";

class Heading extends Component {



    render() {
        return ( 
            
            
           
           < div className = "col-lg-12 col-md-12 col-sm-12 col-xsm-12 mx-auto mt-1 text-center" >


           
            <h2 > < b style={{color:'white'}}> Let 's generate your Resume!</b></h2  > 
            <pre className = "lead" /> Please provide accurate and clear description wherever necessary. < pre/> 
            
            
            </div> 
              
            
           
        )

    }
}

export default Heading;